<template>
  <div class="section">
    <section-header v-if="!hideTitle"
                    :ressource="ressource"
                    :isExtended="extended"
                    :dialog="dialog"
                    @extended=setExtended
                    @closeDialog=closeDialog
                    ref="DPAE">
    </section-header>

    <div v-if="extended">
      <div :class="dialog ? 'p-15' : 'pt-2 pb-5'">
        <div class="text" v-html="getInfo()"></div>
      </div>

      <div class="d-flex flex-row-reverse">
        <div v-for="(state, index) in state.actions" :key="index">
          <loader-button class="ms-2"
                         type="submit"
                         :label="state"
                         @callback="callBack(index)">
          </loader-button>
        </div>
      </div>


    </div>
  </div>
</template>

<script lang="ts">
import CrudContrat from '@/generated/cruds/CrudContrat';
import { GenSection, RessourceGenSection } from '@/generated/ressources/generatedRessources';
import State from '@/generated/classes/State';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import Etablissement from '@/generated/classes/Etablissement'
import { storeEtablissement } from '@/generated/stores';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: CrudContrat,
  props: {
    hideTitle: {
      type: Boolean
    }
  },
  data() {
    return {
      lockAction: false,
      activeState: new State()
    };
  },
  computed: {
    ressource() {
      return RessourceGenSection(GenSection.AFFILIATION_PROCESS);
    },
    etablissement(): Etablissement {
      return storeEtablissement.getEtablissement(this.editContrat.etablissementId);
    },
    state(): State {
      if (this.activeState.objId != this.etablissement.id) {
        this.updateState();
        this.callBack();
      }
      else if (this.activeState.statut != this.etablissement.poleEmploiStatut) {
        this.callBack();
      }
      return this.activeState;
    }
  },
  methods: {
    updateState() {
      this.activeState.objType = ObjTypes.POLE_EMPLOI_STATUT;
      this.activeState.objId = this.etablissement.id;
      this.activeState.statut = this.etablissement.poleEmploiStatut;
    },
    getInfo(): string {
      return this.activeState.info;
    },
    callBack(index?: number) {
      if (!this.lockAction) {
        this.lockAction = true;
        if (index != null) {
          this.state.actionIndex = index + 1;
        } else {
          this.state.actionIndex = 0;
        }
        State.process(this.state).then((res) => {
          this.activeState = res;
          this.lockAction = false;
        }).catch(() => {
          this.lockAction = false;
        });
      }
    }
  }
})

</script>

<style scoped>
  td {
    padding: 10px !important;
  }
</style>
